export default {"src":"/login-app/[GIT_HASH]/_next/static/media/hybrid.d23a41ae.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};